export default __webpack_public_path__ + "locales/ja-JP/Settings.json?hash=004b585415f91d021067140ecff19a17";